"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MouseTooltip;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MouseTooltipContext = _interopRequireDefault(require("../MouseTooltipContext"));

var _MouseTooltipModule = _interopRequireDefault(require("./MouseTooltip.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TOOLTIP_OFFSET_X = 5;
var TOOLTIP_OFFSET_Y = 15;

function getDocumentHeight() {
  var _document = document,
      body = _document.body,
      documentElement = _document.documentElement;
  var height = Math.max(body.scrollHeight, body.offsetHeight, documentElement.clientHeight, documentElement.scrollHeight, documentElement.offsetHeight);
  return height;
}

function getDocumentWidth() {
  var _document2 = document,
      body = _document2.body,
      documentElement = _document2.documentElement;
  var width = Math.max(body.scrollWidth, body.offsetWidth, documentElement.clientWidth, documentElement.scrollWidth, documentElement.offsetWidth);
  return width;
}

function MouseTooltip(_ref) {
  var _ref$offsetX = _ref.offsetX,
      offsetX = _ref$offsetX === void 0 ? TOOLTIP_OFFSET_X : _ref$offsetX,
      _ref$offsetY = _ref.offsetY,
      offsetY = _ref$offsetY === void 0 ? TOOLTIP_OFFSET_Y : _ref$offsetY,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useContext = (0, _react.useContext)(_MouseTooltipContext.default),
      getContent = _useContext.getContent,
      isVisible = _useContext.isVisible;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMouseMoved = _useState2[0],
      setIsMouseMoved = _useState2[1]; // TODO: const [isListenerActive, setIsListenerActive] = useState<boolean>(false);


  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      posX = _useState4[0],
      setPosX = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      posY = _useState6[0],
      setPosY = _useState6[1];

  var tooltipDivRef = _react.default.useRef(null);

  var getTooltipPositionX = (0, _react.useCallback)(function (mousePosX) {
    if (!(tooltipDivRef !== null && tooltipDivRef !== void 0 && tooltipDivRef.current)) return 0;
    var width = tooltipDivRef.current.clientWidth;
    var documentWidth = getDocumentWidth();
    var wouldOverlap = mousePosX > documentWidth / 2;
    var ret = mousePosX + offsetX;
    if (wouldOverlap) ret = mousePosX - width - offsetX;
    return ret;
  }, [offsetX]);
  var getTooltipPositionY = (0, _react.useCallback)(function (mousePosY) {
    if (!(tooltipDivRef !== null && tooltipDivRef !== void 0 && tooltipDivRef.current)) return 0;
    var height = tooltipDivRef.current.clientHeight;
    var documentHeight = getDocumentHeight();
    var wouldOverlap = mousePosY > documentHeight / 2;
    var ret = mousePosY + offsetY;
    if (wouldOverlap) ret = mousePosY - height - offsetY;
    return ret;
  }, [tooltipDivRef, offsetY]);
  var updateTooltipPosition = (0, _react.useCallback)(function (event) {
    var mousePosX = event.clientX;
    var mousePosY = event.clientY;
    setPosX(getTooltipPositionX(mousePosX));
    setPosY(getTooltipPositionY(mousePosY));
    setIsMouseMoved(true);
  }, [getTooltipPositionX, getTooltipPositionY]);
  var addListener = (0, _react.useCallback)(function () {
    window.addEventListener("mousemove", updateTooltipPosition); // setIsListenerActive(true);
  }, [updateTooltipPosition]);
  /*
  TODO:
  const removeListener = useCallback((): void => {
    window.removeEventListener("mousemove", updateTooltipPosition);
    setIsListenerActive(false);
  }, [updateTooltipPosition]);
   const updateListener = useCallback((): void => {
    if (!isListenerActive && isVisible) addListener();
    if (isListenerActive && !isVisible) removeListener();
  }, [addListener, isListenerActive, isVisible, removeListener]);
  */

  (0, _react.useEffect)(function () {
    addListener(); // updateListener();
  }, [addListener]);
  if (!isVisible) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: tooltipDivRef,
    className: (0, _classnames.default)(_MouseTooltipModule.default.mouseTooltip, className),
    style: _objectSpread(_objectSpread({}, style), {}, {
      display: isVisible && isMouseMoved ? "block" : "none",
      position: "fixed",
      top: posY,
      left: posX
    })
  }, getContent());
}